import { useTranslation } from 'next-i18next'

import SplashScreenAvatar from '~/bootcamp/components/Quiz/SplashScreenAvatar'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function AvatarInfo({
  title,
  imageURL,
  flipAvatar,
  isMobile,
  isExists,
  isAwsImage,
}: {
  title: string
  imageURL: string
  flipAvatar?: boolean
  isMobile?: boolean
  isExists: boolean
  isAwsImage?: boolean
}): React.ReactElement {
  const queries = [
    { screen: '(min-width: 639px)', width: '400px', srcKey: 'gamification/BossBattle/SplashScreen/Frame.png' },
    { screen: '(max-width: 640px)', width: '148px', srcKey: 'gamification/BossBattle/SplashScreen/Frame Mobile.png' },
  ]
  const { t } = useTranslation('imageAlt')

  return (
    <div className="max-h-106 sm:max-h-150 w-42 sm:w-59 z-20 flex flex-col justify-between overflow-wrap break-words">
      <ResponsiveImage
        alt={t('avatarFrame')}
        height={380}
        imageClassName="absolute z-10 ml-2 mt-2 sm:mt-0 sm:ml-0 w-37 md:w-57"
        mediaQuery={queries}
        srcKey="gamification/BossBattle/SplashScreen/Frame Mobile.png"
        width={isMobile ? 148 : 226}
      />

      <h3 className="flex justify-center font-extrabold -mt-1 sm:-mt-4 -ml-1 sm:-ml-2 text-white text-l sm:text-2xl">
        {title}
      </h3>
      <div className=" mt-2 ml-2 sm:ml-0 sm:mt-0 h-94.5 w-36.5 sm:w-56 rounded-20 sm:rounded-30 absolute bg-gradient-to-t from-purple via-transparent overflow-hidden">
        <div className="flex justify-center w-36 sm:w-56 sm:ml-1 mt-18 sm:mt-14 overflow-hidden rounded">
          <SplashScreenAvatar
            flip={flipAvatar}
            isAwsImage={isAwsImage}
            isExists={isExists}
            isMobile={isMobile}
            src={imageURL}
          />
        </div>
      </div>
    </div>
  )
}
